import { checkAuthAction } from "../actions/check-auth.action";
import { syncI18nLocaleFromUser } from "@/i18n";

export async function isAuthenticatedGuard(to, from, next) {
  // Check if the route is public
  if (to.meta && to.meta.public) {
    next();
    return;
  }

  // Fallback explícito para rutas públicas de auth
  if (to.path === "/login" || to.path === "/register") {
    next();
    return;
  }

  const isLoggedIn = !!localStorage.getItem("token");

  if (isLoggedIn) {
    // Verificar si necesita aceptar términos
    try {
      const statusResp = await checkAuthAction();

      if (statusResp.transient) {
        syncI18nLocaleFromUser(undefined);
        // Servidor no alcanzable o reinicio: confiar en el token local
        if (to.path === from.path) {
          next(false);
        } else {
          next();
        }
        return;
      }

      if (!statusResp.ok) {
        // Si no está autenticado, redirigir al login
        next("/login");
        return;
      }

      syncI18nLocaleFromUser(statusResp.user);

      if (statusResp.needsToAcceptTerms) {
        // Si necesita aceptar términos, redirigir al login para mostrar el modal
        // Guardar la ruta destino para redirigir después de aceptar
        localStorage.setItem("pendingRoute", to.fullPath);
        next("/login");
        return;
      }
    } catch (error) {
      console.error("Error checking auth status:", error);
      if (localStorage.getItem("token")) {
        if (to.path === from.path) {
          next(false);
        } else {
          next();
        }
        return;
      }
      next("/login");
      return;
    }

    // Solo permitir navegación si no necesita aceptar términos
    if (to.path === from.path) {
      next(false); // Evita la navegación
    } else {
      next(); // Permite la navegación
    }
  } else {
    const orderPathPattern = /^\/order\/\d+$/;
    const sharedFilePattern = /^\/file\/.+/;
    if (orderPathPattern.test(to.path) || sharedFilePattern.test(to.path)) {
      next();
    } else {
      next("/login");
    }
  }
}

export default isAuthenticatedGuard;
